import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppService } from '../app.service';
import { Formio } from 'formiojs';
import { Guid } from 'guid-typescript';
import { FormioExport } from 'formio-export';

@Component({
  selector: 'app-nt-application-component',
  templateUrl: './nt-application.component.html'
})
export class NtApplicationComponent {
    formSpec: any;
    formData: any;
    formId = Guid.create().toJSON().value;
    router: Router;
    appService: any;
    httpClient: HttpClient;
    baseUrl: string;
    ngxLoader: NgxUiLoaderService;
    jsonDataUrl: string;
    constructor(router: Router, appService: AppService, httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, ngxLoader: NgxUiLoaderService, private route: ActivatedRoute) {
        this.router = router;
        this.appService = appService;
        this.httpClient = httpClient;
        this.baseUrl = baseUrl;
        this.ngxLoader = ngxLoader;
        this.route.queryParamMap
          .subscribe(params => {
            this.jsonDataUrl = params.get('jsonUrl')
        });
    }

    ngOnInit(){

        // this.formSpec = {
        //     "title": "NT Application Form",
    var formData;
    var httpClient = this.httpClient;
    var baseUrl = this.baseUrl;
    var that = this;
    var jsonDataUrl = this.jsonDataUrl;
    var formId = this.formId;
    // this.formSpec = {

    var formComponents = [
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "NT Construction Contracts Act: An Overview",
          "inputMask": "",
          "key": "ntConstructionContractsActText",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "This form is designed to help you through the process of making an adjudication application under the Construction Contracts (Security of Payments) Act (NT). Please note that this form applies only to construction work or related goods or services which was carried out in the Northern Territory.",
          "inputMask": "",
          "key": "theFormDesignText",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "For a more detailed overview of the processes outlined by the Act and its purpose, please follow this <a target='_blank' href='https://classic.austlii.edu.au/au/legis/nt/consol_act/ccopa2004520/' target='_blank'>link</a>",
          "inputMask": "",
          "key": "moreDetailedOverviewText",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true
        },
        {
          "type": "radio",
          "label": "Did the construction work take place within the NT?",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "didTheConstructionProjectTakePlaceWIthinNT",
          "persistent": true,
          values: [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
          ],
          "validate": {
            "required": true
          }
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "Invalid application",
          "inputMask": "",
          "key": "formInvalidApplication",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.didTheConstructionProjectTakePlaceWIthinNT"
                },
                "no"
              ],
            }
          }

        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "Please note that for an application to be valid it must comply with s28(1) standards of service. Please click <a href='https://classic.austlii.edu.au/au/legis/nt/consol_act/ccopa2004520/s28.html' target='_blank'>here</a> to know more",
          "inputMask": "",
          "key": "validApplicationText",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "In addition, the work must fall within the definition of either construction work as laid out in <a target='_blank' href='https://classic.austlii.edu.au/au/legis/nt/consol_act/ccopa2004520/s6.html'>s6</a> of the Act or related goods and services as laid out in <a target='_blank' href='https://classic.austlii.edu.au/au/legis/nt/consol_act/ccopa2004520/s7.html'>s7</a> of the Act.",
          "inputMask": "",
          "key": "shouldFallUnderDefinitionOfConstructionWork",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true
        },
        {
          "type": "radio",
          "label": "Does my contract refer to works encompassed by either s6 or s7 of the Act?",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "doesMyContractReferToWorkByS6orS7",
          "persistent": true,
          values: [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
          ],
          "validate": {
            "required": true
          }
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "Invalid application",
          "inputMask": "",
          "key": "formInvalidApplicationByS6OrS7",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.doesMyContractReferToWorkByS6orS7"
                },
                "no"
              ],
            }
          }

        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "Please note that any application which is the subject of an order, judgment or other finding by an arbitrator or other person or a court or other body dealing with a matter arising under a construction contract is invalid under s27(b) of the Act. Additionally, an adjudicator may decline to adjudicate on any matter which they deem too complex to fairly make a determination under s33(1)(a)(iv) of the Act. Please click <a target='_blank' href='https://classic.austlii.edu.au/au/legis/nt/consol_act/ccopa2004520/s33.html'>here</a> to know more",
          "inputMask": "",
          "key": "formInvalidApplicationByS6OrS7",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true
        },
        {
          "type": "radio",
          "label": "What was the construction relationship?",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "whatWasTheConstructionRelationShip",
          "persistent": true,
          values: [
            { value: 'headContractorSubcontractor', label: 'Head Contractor/subcontractor' },
            { value: 'headContractorPrincipalOrClient', label: 'Head contractor/principal (or client)' },
            { value: 'subcontractorSubcontractor', label: 'Subcontractor/subcontractor' }
          ],
          "validate": {
            "required": true
          }
        },
        {
          "label": "On which date was the contract entered into between the Applicant and the Respondent?",
          "format": "dd-MMM-yyyy",
          "tableView": false,
          "enableMinDateInput": false,
          "datePicker": {
            "disableWeekends": false,
            "disableWeekdays": false
          },
          "enableMaxDateInput": false,
          "enableTime": false,
          "timePicker": {
            "showMeridian": false
          },
          // conditional: {
          // "json": {
          //     "===": [
          //     {
          //         "var": "data.terms"
          //     },
          //     "yes"
          //     ]
          // }
          // },
          "key": "onWhichDateWasTheContractEntered",
          "type": "datetime",
          "input": true,
          "widget": {
            "type": "calendar",
            "displayInTimezone": "viewer",
            "locale": "en",
            "useLocaleSettings": false,
            "allowInput": true,
            "mode": "single",
            "enableTime": false,
            "noCalendar": false,
            "format": "dd-MMM-yyyy",
            "hourIncrement": 1,
            "minuteIncrement": 1,
            "time_24hr": true,
            "minDate": null,
            "disableWeekends": false,
            "disableWeekdays": false,
            "maxDate": null
          }
        },
        {
          "type": "textarea",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Please provide a brief description of your contract",
          "key": "briefDescriptionOfYourContract",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "radio",
          "label": "Is there a written contract?",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "isThereAWrittenContract",
          "persistent": true,
          values: [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
          ],
          "validate": {
            "required": true
          }
        },
        {
          "type": "fileupload",
          "label": "Please provide a copy of this contract or relevant extracts.",
          "disabled": false,
          "placeholder": "Claimant contract documents",
          conditional: {
            "json": {
              "===": [
                {
                  "var": "data.formName"
                },
                "nt-application"
              ]
            }
          }
        },
        // Please provide a copy of the contract upload component should be added
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "If you have carried out relevant work under the Act and are entitled to a progress payment, you may serve a “payment claim” on the party who is liable to pay you. Details of how this should be done will usually be found in your contract. If your contract does not contain information about payment claims then the terms laid out in Schedule 1 of the Act will be implied.",
          "inputMask": "",
          "key": "formInvalidApplicationByS6OrS7",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true
        },
        {
          "type": "radio",
          "label": "Did you submit a payment claim?",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "didYouSubmitAPaymentClaim",
          "persistent": true,
          values: [
            { value: 'yes', label: 'Yes' },
            { value: 'no)', label: 'No' }
          ],
          "validate": {
            "required": true
          }
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "Invalid application",
          "inputMask": "",
          "key": "didYouSubmitAPaymentClaimInvalidApplication",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.didYouSubmitAPaymentClaim"
                },
                "no"
              ]
            }
          }
        },
        {
          "label": "On what date did you make a payment claim?",
          "format": "dd-MMM-yyyy",
          "tableView": false,
          "enableMinDateInput": false,
          "datePicker": {
            "disableWeekends": false,
            "disableWeekdays": false
          },
          "enableMaxDateInput": false,
          "enableTime": false,
          "timePicker": {
            "showMeridian": false
          },
          // conditional: {
          // "json": {
          //     "===": [
          //     {
          //         "var": "data.terms"
          //     },
          //     "yes"
          //     ]
          // }
          // },
          "key": "onWhatDateDidYouMakeAPaymentClaim",
          "type": "datetime",
          "input": true,
          "widget": {
            "type": "calendar",
            "displayInTimezone": "viewer",
            "locale": "en",
            "useLocaleSettings": false,
            "allowInput": true,
            "mode": "single",
            "enableTime": false,
            "noCalendar": false,
            "format": "dd-MMM-yyyy",
            "hourIncrement": 1,
            "minuteIncrement": 1,
            "time_24hr": true,
            "minDate": null,
            "disableWeekends": false,
            "disableWeekdays": false,
            "maxDate": null
          }
        },
        {
          "label": "What amount was claimed?",
          "mask": false,
          "spellcheck": true,
          "tableView": false,
          "currency": "AUD",
          "inputFormat": "plain",
          "key": "amountClaimed",
          "type": "currency",
          "input": true,
          "delimiter": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        // Please provide a copy of the payment claim add upload component
        {
          "type": "fileupload",
          "label": "Please provide a copy of the payment claim or relevant details of the payment claim.",
          "disabled": false,
          "placeholder": "Payment claim documents",
          conditional: {
            "json": {
              "===": [
                {
                  "var": "data.formName"
                },
                "nt-application"
              ]
            }
          }
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "If you have made a payment claim, and it has either been disputed or not paid, then your eligibility to apply for adjudication will depend on whether a “payment dispute” has arisen. The definition of a payment dispute can be found in s8 of the Act. Please click <a href='https://classic.austlii.edu.au/au/legis/nt/consol_act/ccopa2004520/s8.html' target='_blank'>here</a> to know more.",
          "inputMask": "",
          "key": "didYouSubmitAPaymentClaimInvalidApplication",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true
        },
        {
          "label": "Date of payment dispute",
          "format": "dd-MMM-yyyy",
          "tableView": false,
          "enableMinDateInput": false,
          "datePicker": {
            "disableWeekends": false,
            "disableWeekdays": false
          },
          "enableMaxDateInput": false,
          "enableTime": false,
          "timePicker": {
            "showMeridian": false
          },
          // conditional: {
          // "json": {
          //     "===": [
          //     {
          //         "var": "data.terms"
          //     },
          //     "yes"
          //     ]
          // }
          // },
          "key": "dateOfPaymentDispute",
          "type": "datetime",
          "input": true,
          "widget": {
            "type": "calendar",
            "displayInTimezone": "viewer",
            "locale": "en",
            "useLocaleSettings": false,
            "allowInput": true,
            "mode": "single",
            "enableTime": false,
            "noCalendar": false,
            "format": "dd-MMM-yyyy",
            "hourIncrement": 1,
            "minuteIncrement": 1,
            "time_24hr": true,
            "minDate": null,
            "disableWeekends": false,
            "disableWeekdays": false,
            "maxDate": null
          }
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "s28 of the Act requires that any adjudication application must be within 90 calendar days of the payment dispute arising. Please click <a target='_blank' href='http://www7.austlii.edu.au/cgi-bin/viewdoc/au/legis/nt/consol_act/ccopa2004520/s28.html'>here</a> to know more.",
          "inputMask": "",
          "key": "didYouSubmitAPaymentClaimInvalidApplication",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true,
          "customClass": "orangeText",
          conditional: {
            "json": {
              "and": [
                { "<": [{ "var": "data.dateOfPaymentDispute" }, moment().add(-90, 'days').toISOString()] },
                { ">": [{ "var": "data.dateOfPaymentDispute" }, "0000-00-00T00:00:00+11:00"] }
              ]
            }

          }
        },
        {
          "label": "Amount not paid, whether in whole or in part, at the point in time of commencing this application for adjudication (exclusive of GST)",
          "mask": false,
          "spellcheck": true,
          "tableView": false,
          "currency": "AUD",
          "inputFormat": "plain",
          "key": "amountNotPaidInWholeOrInPart",
          "type": "currency",
          "input": true,
          "delimiter": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        // If applicable, please attach a copy of the notice of dispute
        // add upload component
        //   {
        //     "type": "htmlelement",
        //     "input": false,
        //     "tableView": true,
        //     "content": "Applicant",
        //     "inputMask": "",
        //     "key": "applicantText",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true
        //   },
        //   // Adding fields for applicant
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Business name",
        //     "key": "businessName",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Contact Given name",
        //     "key": "applicantContactGivenName",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Contact Surname",
        //     "key": "applicantContactSurname",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "ABN/ACN",
        //     "key": "applicantABN",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "button",
        //     "label": "Check",
        //     "key": "check",
        //     "disableOnInvalid": false,
        //     "input": true,
        //     "tableView": true,
        //     "action": "custom",
        //     "custom": "window.onCheck(data.applicantABN)",
        //     "conditional": {
        //       "json": {
        //         "===": [
        //           {
        //             "var": "data.terms"
        //           },
        //           "yes"
        //         ]
        //       }
        //     }
        //   },
        //   {
        //     "type": "htmlelement",
        //     "input": false,
        //     "tableView": true,
        //     "content": "ABN is valid",
        //     "inputMask": "",
        //     "key": "abnValidText",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "customClass": "abnSuccess",
        //     "conditional": {
        //       "json": {
        //         "==": [
        //           {
        //             "var": "data.displayabnValidationSuccess"
        //           },
        //           true
        //         ]
        //       }
        //     }
        // },
        // {
        //     "type": "htmlelement",
        //     "input": false,
        //     "tableView": true,
        //     "content": "ABN is not valid",
        //     "inputMask": "",
        //     "key": "abnNotValidText",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "customClass": "abnFailure",
        //     "conditional": {
        //       "json": {
        //         "==": [
        //           {
        //             "var": "data.displayabnValidationFailure"
        //           },
        //           true
        //         ]
        //       }
        //     }
        // },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Postal Address",
        //     "key": "applicantPostalAddress",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Suburb",
        //     "key": "applicantSuburb",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "State",
        //     "key": "applicantState",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "PostCode",
        //     "key": "applicantPostCode",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false,
        //         "pattern": "^[0-9]+$"
        //     }
        //   },
        //   {
        //     "label": "Telephone number",
        //     "inputMask": "(99) 9999-9999",
        //     "tableView": true,
        //     "persistent": true,
        //     "validate": {
        //         "required": false,
        //         "customPrivate": false
        //     },
        //     "key": "applicantTelephoneNumber",
        //     "type": "textfield",
        //     "input": true
        //   },

        //   {
        //     "label": "Email",
        //     "tableView": true,
        //     "validate": {
        //         "required": true
        //     },
        //     "key": "applicantEmail",
        //     "type": "email",
        //     "input": true
        //   },
        //   // Add representative
        //   {
        //     "type": "radio",
        //     "label": "Did the applicant have a representative?",
        //     "input": true,
        //     "inline": true,
        //     "tableView": false,
        //     "key": "didTheApplicantHaveRepresentative",
        //     "persistent": true,
        //     values: [
        //         {value: 'yes', label: 'Yes'},
        //         {value: 'no', label: 'No'}
        //     ],
        //     "validate": {
        //         "required": true
        //     }
        // },
        // // Add firm, name, postal address, suburb, state, postcode, tele
        // {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Firm/Chambers",
        //     "key": "representative1FirmChambers",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheApplicantHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Name of representative",
        //     "key": "nameOfRepresentative1",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheApplicantHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Postal Address",
        //     "key": "representative1PostalAddress",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheApplicantHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Suburb",
        //     "key": "representative1Suburb",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheApplicantHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "State",
        //     "key": "representative1State",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheApplicantHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "PostCode", // Add validation for only numbers
        //     "key": "representative1PostCode",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheApplicantHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       },
        //     "validate": {
        //         "pattern": "^[0-9]+$"
        //     }
        //   },
        //   {
        //     "label": "Telephone number",
        //     "inputMask": "(99) 9999-9999",
        //     "tableView": true,
        //     "persistent": true,
        //     "key": "representative1TelephoneNumber",
        //     "type": "textfield",
        //     "input": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheApplicantHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   // Add firm, name, postal address, suburb, state, postcode, tele end
        //   {
        //     "type": "htmlelement",
        //     "input": false,
        //     "tableView": true,
        //     "content": "Respondent Details",
        //     "inputMask": "",
        //     "key": "respondentDetailsText",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Business name",
        //     "key": "respondentBusinessName",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Contact person",
        //     "key": "respondentContactPerson",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "ABN/ACN",
        //     "key": "respondentABN",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "button",
        //     "label": "Check",
        //     "key": "checkRespondentBN",
        //     "disableOnInvalid": false,
        //     "input": true,
        //     "tableView": true,
        //     "action": "custom",
        //     "custom": "window.onCheck1(data.respondentABN)",
        //     // disabled: "window.checkValid(data.applicantABN)",
        //     conditional: {
        //       "json": {
        //         "===": [
        //           {
        //             "var": "data.terms"
        //           },
        //           "yes"
        //         ]
        //       }
        //     }
        //   },
        //   {
        //     "type": "htmlelement",
        //     "input": false,
        //     "tableView": true,
        //     "content": "ABN is valid",
        //     "inputMask": "",
        //     "key": "abnValidTextRespondent",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "customClass": "abnSuccess",
        //     "conditional": {
        //       "json": {
        //         "==": [
        //           {
        //             "var": "data.displayabnValidationSuccessRespondent"
        //           },
        //           true
        //         ]
        //       }
        //     }
        // },
        // {
        //     "type": "htmlelement",
        //     "input": false,
        //     "tableView": true,
        //     "content": "ABN is not valid",
        //     "inputMask": "",
        //     "key": "abnNotValidTextRespondent",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "customClass": "abnFailure",
        //     "conditional": {
        //       "json": {
        //         "==": [
        //           {
        //             "var": "data.displayabnValidationFailureRespondent"
        //           },
        //           true
        //         ]
        //       }
        //     }
        // },    
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Postal Address",
        //     "key": "respondentPostalAddress",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Suburb",
        //     "key": "respondentSuburb",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "State",
        //     "key": "respondentState",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "PostCode",
        //     "key": "respondentPostCode",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false,
        //         "pattern": "^[0-9]+$"
        //     }
        //   },
        //   {
        //     "label": "Telephone number",
        //     "inputMask": "(99) 9999-9999",
        //     "tableView": true,
        //     "persistent": true,
        //     "validate": {
        //         "required": false,
        //         "customPrivate": false
        //     },
        //     "key": "respondentTelephoneNumber",
        //     "type": "textfield",
        //     "input": true
        //   },

        //   {
        //     "label": "Email",
        //     "tableView": true,
        //     "validate": {
        //         "required": true
        //     },
        //     "key": "respondentEmail",
        //     "type": "email",
        //     "input": true
        //   },
        {
          "title": "Applicant details",
          "collapsible": true,
          "key": "panel",
          "type": "panel",
          "label": "Panel",
          "input": false,
          "tableView": false,
          "components": [
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "Name of Applicant (Company)",
              "key": "applicantName",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "ABN/ACN",
              "key": "applicantABN",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false,
                "pattern": "^[0-9]+$"
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "button",
              "label": "Check",
              "key": "check",
              "disableOnInvalid": false,
              "input": true,
              "tableView": true,
              "action": "custom",
              "custom": "window.onCheck(data.applicantABN)",
              // "conditional": {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "ABN is valid",
              "inputMask": "",
              "key": "abnValidText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "customClass": "abnSuccess",
              "conditional": {
                "json": {
                  "==": [
                    {
                      "var": "data.displayabnValidationSuccess"
                    },
                    true
                  ]
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "ABN is not valid",
              "inputMask": "",
              "key": "abnNotValidText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "customClass": "abnFailure",
              "conditional": {
                "json": {
                  "==": [
                    {
                      "var": "data.displayabnValidationFailure"
                    },
                    true
                  ]
                }
              }
            },
            {
              type: "select",
              label: "Business Structure",
              key: "applicantBusinessStructure",
              placeholder: "Select one",
              data: {
                values: [
                  { value: 'Commonwealth Government', label: 'Commonwealth Government' },
                  { value: 'Incorporated Association', label: 'Incorporated Association' },
                  { value: 'Local Government', label: 'Local Government' },
                  { value: 'Ltd Company', label: 'Ltd Company' },
                  { value: 'Local Government', label: 'Local Government' },
                  { value: 'Partnership', label: 'Partnership' },
                  { value: 'Pty Ltd Company', label: 'Pty Ltd Company' },
                  { value: 'Sole trader', label: 'Sole trader' },
                  { value: 'State Government', label: 'State Government' },
                  { value: 'Trust', label: 'Trust' },
                  { value: 'Other', label: 'Other' }
                ]
              },
              dataSrc: "values",
              validate: {
                required: true
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // },
              defaultValue: '',
              template: "<span>{{ item.label }}</span>",
              input: true
            },
            // this is for nsw and all other states
            // {
            //   type: "select",
            //   label: "Business Type/Activity",
            //   key: "applicantBusinessType",
            //   placeholder: "Select one",
            //   data: {
            //     values: [
            //       { value: 'Principal', label: 'Principal' },
            //       { value: 'Head contractor', label: 'Head contractor' },
            //       { value: 'Subcontractor', label: 'Subcontractor' },
            //       { value: 'Supplier', label: 'Supplier' },
            //       { value: 'Consultant', label: 'Consultant' },
            //       { value: 'Not Specified', label: 'Not Specified' }
            //     ]
            //   },
            //   dataSrc: "values",
            //   validate: {
            //     required: true
            //   },
            //   // "conditional": {
            //   //   "json": {
            //   //     "and": [
            //   //       // {"==": [{"var": "data.terms"}, "yes"]},
            //   //       // { "in": [{ "var": "data.applicantState" }, ["NSW", "SA", "ACT", "TAS"]] }
            //   //     ]
            //   //   }
            //   // },
            //   defaultValue: '',
            //   template: "<span>{{ item.label }}</span>",
            //   input: true
            // },

            // this is for VIC - has special list
            // {
            //   type: "select",
            //   label: "Business Type/Activity",
            //   key: "applicantBusinessType",
            //   placeholder: "Select one",
            //   data: {
            //     values: [
            //       { value: 'Consultant', label: 'Consultant' },
            //       { value: 'Developer', label: 'Developer' },
            //       { value: 'Head contractor', label: 'Head contractor' },
            //       { value: 'Major subcontractor', label: 'Major subcontractor' },
            //       { value: 'Manufacturer of building materials or components', label: 'Manufacturer of building materials or components' },
            //       { value: 'Project manager', label: 'Project manager' },
            //       { value: 'Supplier', label: 'Supplier' },
            //       { value: 'Trade subcontractor', label: 'Trade subcontractor' },
            //       { value: 'Other', label: 'Other' }
            //     ]
            //   },
            //   dataSrc: "values",
            //   validate: {
            //     required: true
            //   },
            //   // "conditional": {
            //   //   "json": {
            //   //     "and": [
            //   //       // {"==": [{"var": "data.terms"}, "yes"]},
            //   //       // { "===": [{ "var": "data.applicantState" }, "VIC"] }
            //   //     ]
            //   //   }
            //   // },
            //   defaultValue: '',
            //   template: "<span>{{ item.label }}</span>",
            //   input: true
            // },

            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Contact Person",
              "inputMask": "",
              "key": "applicantContactPersonText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              // "conditional": {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantContactPersonName",
              "placeholder": "Name",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantContactPersonPosition",
              "placeholder": "Position",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "customPrivate": false
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Address",
              "inputMask": "",
              "key": "applicantAddressText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              // "conditional": {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantAddressNumberStreet",
              "placeholder": "Number/Street",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantSuburb",
              "placeholder": "Suburb",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantState",
              "placeholder": "State",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "applicantPostCode",
              "placeholder": "Postcode",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "label": "Phone",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // },
              "key": "applicantPhone",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Fax",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // },
              "key": "applicantFax",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Email",
              "tableView": true,
              "validate": {
                "required": true
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // },
              "key": "applicantEmail",
              "type": "email",
              "input": true
            },
            {
              type: "select",
              label: "Does the applicant retain advisors?",
              key: "retainAdvisers",
              placeholder: "Select one",
              data: {
                values: [
                  { value: 'claimPreparer', label: 'Claim preparer' },
                  { value: 'consultant', label: 'Consultant' },
                  { value: 'solicitors', label: 'Solicitors' },
                  { value: 'none', label: 'None' },
                  { value: 'notKnown', label: 'Not known' }
                ]
              },
              dataSrc: "values",
              defaultValue: '',
              template: "<span>{{ item.label }}</span>",
              input: true,
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            //start for retain advisors
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Contact Person",
              "inputMask": "",
              "key": "retailAdvisorContactPersonText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorContactPersonName",
              "placeholder": "Name",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorContactPersonPosition",
              "placeholder": "Position",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Address",
              "inputMask": "",
              "key": "retailAdvisorAddressText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorAddressNumberStreet",
              "placeholder": "Number/Street",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorSuburb",
              "placeholder": "Suburb",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorState",
              "placeholder": "State",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "retailAdvisorPostCode",
              "placeholder": "Postcode",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "label": "Phone",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              },
              "key": "retailAdvisorPhone",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Fax",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              },
              "key": "retailAdvisorFax",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Email",
              "tableView": true,
              "validate": {
                "required": true
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.retainAdvisers"
                    },
                    ["claimPreparer", "consultant", "solicitors"]
                  ]
                }
              },
              "key": "retailAdvisorEmail",
              "type": "email",
              "input": true
            }
          ],
          // conditional: {
          //   "json": {
          //     "===": [
          //       {
          //         "var": "data.terms"
          //       },
          //       "yes"
          //     ]
          //   }
          // }
        },

        //end for retain advisors

        // start all fields from beginning for respondant
        {
          "title": "Respondent details",
          "collapsible": true,
          "key": "panel",
          "type": "panel",
          "label": "Panel",
          "input": false,
          "tableView": false,
          "components": [
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "Company (Respondent)",
              "key": "respondentName",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              //   conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "ABN/ACN",
              "key": "respondentABN",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "button",
              "label": "Check",
              "key": "checkRespondentBN",
              "disableOnInvalid": false,
              "input": true,
              "tableView": true,
              "action": "custom",
              "custom": "window.onCheck1(data.respondentABN)",
              // disabled: "window.checkValid(data.applicantABN)",
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "ABN is valid",
              "inputMask": "",
              "key": "abnValidTextRespondent",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "customClass": "abnSuccess",
              "conditional": {
                "json": {
                  "==": [
                    {
                      "var": "data.displayabnValidationSuccessRespondent"
                    },
                    true
                  ]
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "ABN is not valid",
              "inputMask": "",
              "key": "abnNotValidTextRespondent",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "customClass": "abnFailure",
              "conditional": {
                "json": {
                  "==": [
                    {
                      "var": "data.displayabnValidationFailureRespondent"
                    },
                    true
                  ]
                }
              }
            },

            {
              type: "select",
              label: "Business Structure",
              key: "respondentBusinessStructure",
              placeholder: "Select one",
              data: {
                values: [
                  { value: 'Commonwealth Government', label: 'Commonwealth Government' },
                  { value: 'Incorporated Association', label: 'Incorporated Association' },
                  { value: 'Local Government', label: 'Local Government' },
                  { value: 'Ltd Company', label: 'Ltd Company' },
                  { value: 'Local Government', label: 'Local Government' },
                  { value: 'Partnership', label: 'Partnership' },
                  { value: 'Pty Ltd Company', label: 'Pty Ltd Company' },
                  { value: 'Sole trader', label: 'Sole trader' },
                  { value: 'State Government', label: 'State Government' },
                  { value: 'Trust', label: 'Trust' },
                  { value: 'Other', label: 'Other' }
                ]
              },
              dataSrc: "values",
              validate: {
                required: true
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // },
              defaultValue: '',
              template: "<span>{{ item.label }}</span>",
              input: true
            },

            // this is for nsw and all other states
            // {
            //   type: "select",
            //   label: "Business Type/Activity",
            //   key: "respondentBusinessType",
            //   placeholder: "Select one",
            //   data: {
            //     values: [
            //       { value: 'Principal', label: 'Principal' },
            //       { value: 'Head contractor', label: 'Head contractor' },
            //       { value: 'Subcontractor', label: 'Subcontractor' },
            //       { value: 'Supplier', label: 'Supplier' },
            //       { value: 'Consultant', label: 'Consultant' },
            //       { value: 'Not Specified', label: 'Not Specified' }
            //     ]
            //   },
            //   dataSrc: "values",
            //   validate: {
            //     required: true
            //   },
            //   // "conditional": {
            //   //   "json": {
            //   //     "and": [
            //   //       // {"==": [{"var": "data.terms"}, "yes"]},
            //   //       // { "in": [{ "var": "data.applicantState" }, ["NSW", "SA", "ACT", "TAS"]] }
            //   //     ]
            //   //   }
            //   // },
            //   defaultValue: '',
            //   template: "<span>{{ item.label }}</span>",
            //   input: true
            // },

            // this is for VIC - has special list
            // {
            //   type: "select",
            //   label: "Business Type/Activity",
            //   key: "respondentBusinessType",
            //   placeholder: "Select one",
            //   data: {
            //     values: [
            //       { value: 'Consultant', label: 'Consultant' },
            //       { value: 'Developer', label: 'Developer' },
            //       { value: 'Head contractor', label: 'Head contractor' },
            //       { value: 'Major subcontractor', label: 'Major subcontractor' },
            //       { value: 'Manufacturer of building materials or components', label: 'Manufacturer of building materials or components' },
            //       { value: 'Project manager', label: 'Project manager' },
            //       { value: 'Supplier', label: 'Supplier' },
            //       { value: 'Trade subcontractor', label: 'Trade subcontractor' },
            //       { value: 'Other', label: 'Other' }
            //     ]
            //   },
            //   dataSrc: "values",
            //   validate: {
            //     required: true
            //   },
            //   // "conditional": {
            //   //   "json": {
            //   //     "and": [
            //   //       // {"==": [{"var": "data.terms"}, "yes"]},
            //   //       // { "===": [{ "var": "data.applicantState" }, "VIC"] }
            //   //     ]
            //   //   }
            //   // },
            //   defaultValue: '',
            //   template: "<span>{{ item.label }}</span>",
            //   input: true
            // },


            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Contact Person",
              "inputMask": "",
              "key": "respondentContactPersonText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              // "conditional": {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentContactPersonName",
              "placeholder": "Name",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentContactPersonPosition",
              "placeholder": "Position",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //     {
              //       "var": "data.terms"
              //     },
              //     "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Address",
              "inputMask": "",
              "key": "respondentAddressText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              // "conditional": {
              //   "json": {
              //     "===": [
              //       {
              //         "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentAddressNumberStreet",
              "placeholder": "Number/Street",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //     {
              //       "var": "data.terms"
              //     },
              //     "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentSuburb",
              "placeholder": "Suburb",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //     {
              //       "var": "data.terms"
              //     },
              //     "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentState",
              "placeholder": "State",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //       "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentPostCode",
              "placeholder": "Postcode",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //       "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            {
              "label": "Phone",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              // conditional: {
              // "json": {
              // "===": [
              //   {
              //   "var": "data.terms"
              //   },
              //   "yes"
              // ]
              // }
              // },
              "key": "respondentPhone",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Fax",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //       "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // },
              "key": "respondentFax",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Email",
              "tableView": true,
              "validate": {
                "required": true
              },
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //       "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // },
              "key": "respondentEmail",
              "type": "email",
              "input": true
            },
            {
              type: "select",
              label: "Does the respondent retain advisors?",
              key: "respondentRetainAdvisers",
              placeholder: "Select one",
              data: {
                values: [
                  { value: 'responsePreparer', label: 'Response preparer' },
                  { value: 'consultant', label: 'Consultant' },
                  { value: 'solicitors', label: 'Solicitors' },
                  { value: 'none', label: 'None' },
                  { value: 'notKnown', label: 'Not known' }
                ]
              },
              dataSrc: "values",
              defaultValue: '',
              template: "<span>{{ item.label }}</span>",
              input: true,
              // conditional: {
              //   "json": {
              //     "===": [
              //       {
              //       "var": "data.terms"
              //       },
              //       "yes"
              //     ]
              //   }
              // }
            },
            //start for retain advisors
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Contact Person",
              "inputMask": "",
              "key": "respondentRetailAdvisorContactPersonText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.respondentRetainAdvisers"
                    },
                    ["responsePreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentRetailAdvisorContactPersonName",
              "placeholder": "Name",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.respondentRetainAdvisers"
                    },
                    ["responsePreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentRetailAdvisorContactPersonPosition",
              "placeholder": "Position",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.respondentRetainAdvisers"
                    },
                    ["responsePreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Address",
              "inputMask": "",
              "key": "respondentRetailAdvisorAddressText",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.respondentRetainAdvisers"
                    },
                    ["responsePreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentRetailAdvisorAddressNumberStreet",
              "placeholder": "Number/Street",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.respondentRetainAdvisers"
                    },
                    ["responsePreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentRetailAdvisorSuburb",
              "placeholder": "Suburb",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.respondentRetainAdvisers"
                    },
                    ["responsePreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentRetailAdvisorState",
              "placeholder": "State",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.respondentRetainAdvisers"
                    },
                    ["responsePreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "",
              "key": "respondentRetailAdvisorPostCode",
              "placeholder": "Postcode",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.respondentRetainAdvisers"
                    },
                    ["responsePreparer", "consultant", "solicitors"]
                  ]
                }
              }
            },
            {
              "label": "Phone",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.respondentRetainAdvisers"
                    },
                    ["responsePreparer", "consultant", "solicitors"]
                  ]
                }
              },
              "key": "respondentRetailAdvisorPhone",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Fax",
              "inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.respondentRetainAdvisers"
                    },
                    ["responsePreparer", "consultant", "solicitors"]
                  ]
                }
              },
              "key": "respondentRetailAdvisorFax",
              "type": "textfield",
              "input": true
            },
            {
              "label": "Email",
              "tableView": true,
              "validate": {
                "required": true
              },
              conditional: {
                "json": {
                  "in": [
                    {
                      "var": "data.respondentRetainAdvisers"
                    },
                    ["responsePreparer", "consultant", "solicitors"]
                  ]
                }
              },
              "key": "respondentRetailAdvisorEmail",
              "type": "email",
              "input": true
            }
          ],
          // conditional: {
          //   "json": {
          //     "===": [
          //       {
          //         "var": "data.terms"
          //       },
          //       "yes"
          //     ]
          //   }
          // }
        },
        //   {
        //     "type": "radio",
        //     "label": "Did the respondent have a representative?",
        //     "input": true,
        //     "inline": true,
        //     "tableView": false,
        //     "key": "didTheRespondentHaveRepresentative",
        //     "persistent": true,
        //     values: [
        //         {value: 'yes', label: 'Yes'},
        //         {value: 'no', label: 'No'}
        //     ],
        //     "validate": {
        //         "required": true
        //     }
        // },
        // // Add firm, name, postal address, suburb, state, postcode, tele
        // {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Firm/Chambers",
        //     "key": "respondnentRepresentativeFirmChambers",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheRespondentHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Name of representative",
        //     "key": "respondnentNameOfRepresentative",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheRespondentHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Postal Address",
        //     "key": "respondentRepresentativePostalAddress",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheRespondentHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Suburb",
        //     "key": "respondnentRepresentativeSuburb",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheRespondentHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "State",
        //     "key": "respondnentRepresentativeState",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheRespondentHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "PostCode",
        //     "key": "respondnentRepresentativePostCode",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheRespondentHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       },
        //     "validate": {
        //         "pattern": "^[0-9]+$"
        //     }
        //   },
        //   {
        //     "label": "Telephone number",
        //     "inputMask": "(99) 9999-9999",
        //     "tableView": true,
        //     "persistent": true,
        //     "key": "respondnentRepresentativeTelephoneNumber",
        //     "type": "textfield",
        //     "input": true,
        //     conditional: {
        //         "json": {
        //           "===": [
        //             {
        //               "var": "data.didTheRespondentHaveRepresentative"
        //             },
        //             "yes"
        //           ]
        //         }
        //       }
        //   },
        //   // end add firm, name, postal address, suburb, state, postcode, tele
        //   {
        //     "type": "radio",
        //     "label": "Do you have appointed Adjudicator?",
        //     "input": true,
        //     "inline": true,
        //     "tableView": false,
        //     "key": "doYouHaveAppointedAdjudicator",
        //     "persistent": true,
        //     values: [
        //         {value: 'yes', label: 'Yes'},
        //         {value: 'no', label: 'No'}
        //     ],
        //     "validate": {
        //         "required": true
        //     }
        // },
        // {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Contact person",
        //     "key": "adjudicatorContactPerson",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     },
        //     "conditional": {
        //         "json": {
        //             "===": [
        //                 {"var": "data.doYouHaveAppointedAdjudicator"},
        //                 "yes"
        //             ]
        //         }
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "ABN/ACN",
        //     "key": "adjudicatorABN",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     },
        //     "conditional": {
        //         "json": {
        //             "===": [
        //                 {"var": "data.doYouHaveAppointedAdjudicator"},
        //                 "yes"
        //             ]
        //         }
        //     }
        //   },
        //   {
        //     "type": "button",
        //     "label": "CheckAdjudicatorABN",
        //     "key": "checkAdjudicatorABN",
        //     "disableOnInvalid": false,
        //     "input": true,
        //     "tableView": true,
        //     "action": "custom",
        //     "custom": "window.onCheck2(data.adjudicatorABN)",
        //     "conditional": {
        //       "json": {
        //         "===": [
        //           {
        //             "var": "data.terms"
        //           },
        //           "yes"
        //         ]
        //       }
        //     }
        //   },
        //   {
        //     "type": "htmlelement",
        //     "input": false,
        //     "tableView": true,
        //     "content": "ABN is valid",
        //     "inputMask": "",
        //     "key": "abnValidTextAdjudicator",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "customClass": "abnSuccess",
        //     "conditional": {
        //       "json": {
        //         "==": [
        //           {
        //             "var": "data.displayabnValidationSuccessAdjudicator"
        //           },
        //           true
        //         ]
        //       }
        //     }
        // },
        // {
        //     "type": "htmlelement",
        //     "input": false,
        //     "tableView": true,
        //     "content": "ABN is not valid",
        //     "inputMask": "",
        //     "key": "abnNotValidTextAdjudicator",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "customClass": "abnFailure",
        //     "conditional": {
        //       "json": {
        //         "==": [
        //           {
        //             "var": "data.displayabnValidationFailureAdjudicator"
        //           },
        //           true
        //         ]
        //       }
        //     }
        // },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Postal Address",
        //     "key": "adjudicatorPostalAddress",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     },
        //     "conditional": {
        //         "json": {
        //             "===": [
        //                 {"var": "data.doYouHaveAppointedAdjudicator"},
        //                 "yes"
        //             ]
        //         }
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "Suburb",
        //     "key": "adjudicatorSuburb",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     },
        //     "conditional": {
        //         "json": {
        //             "===": [
        //                 {"var": "data.doYouHaveAppointedAdjudicator"},
        //                 "yes"
        //             ]
        //         }
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "State",
        //     "key": "adjudicatorState",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false
        //     },
        //     "conditional": {
        //         "json": {
        //             "===": [
        //                 {"var": "data.doYouHaveAppointedAdjudicator"},
        //                 "yes"
        //             ]
        //         }
        //     }
        //   },
        //   {
        //     "type": "textfield",
        //     "input": true,
        //     "tableView": true,
        //     "inputType": "text",
        //     "inputMask": "",
        //     "label": "PostCode",
        //     "key": "adjudicatorPostCode",
        //     "placeholder": "",
        //     "prefix": "",
        //     "suffix": "",
        //     "multiple": false,
        //     "defaultValue": "",
        //     "protected": false,
        //     "unique": false,
        //     "persistent": true,
        //     "validate": {
        //         "required": true,
        //         "customPrivate": false,
        //         "pattern": "^[0-9]+$"
        //     },
        //     "conditional": {
        //         "json": {
        //             "===": [
        //                 {"var": "data.doYouHaveAppointedAdjudicator"},
        //                 "yes"
        //             ]
        //         }
        //     }
        //   },
        //   {
        //     "label": "Telephone number",
        //     "inputMask": "(99) 9999-9999",
        //     "tableView": true,
        //     "persistent": true,
        //     "validate": {
        //         "required": false,
        //         "customPrivate": false
        //     },
        //     "conditional": {
        //         "json": {
        //             "===": [
        //                 {"var": "data.doYouHaveAppointedAdjudicator"},
        //                 "yes"
        //             ]
        //         }
        //     },
        //     "key": "adjudicatorTelephoneNumber",
        //     "type": "textfield",
        //     "input": true
        //   },

        //   {
        //     "label": "Email",
        //     "tableView": true,
        //     "validate": {
        //         "required": true
        //     },
        //     "conditional": {
        //         "json": {
        //             "===": [
        //                 {"var": "data.doYouHaveAppointedAdjudicator"},
        //                 "yes"
        //             ]
        //         }
        //     },
        //     "key": "adjudicatorEmail",
        //     "type": "email",
        //     "input": true
        //   },
        {
          "title": "Prescribed Appointer",
          "collapsible": true,
          "key": "prescribedAppointerPanel",
          "type": "panel",
          "label": "Panel",
          "input": false,
          "tableView": false,
          "components": [
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "Company Name",
              "key": "prescribedAppointerName",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "disabled": true,
              "validate": {
                "required": true,
                "customPrivate": false
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "ABN/ACN",
              "key": "prescribedAppointerABN",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "disabled": true,
            },
            // Start - Address, tele and email
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "Address Line 1",
              "key": "prescribedAppointerPostalAddress1",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              "disabled": true,
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "Address Line 2",
              "key": "prescribedAppointerPostalAddress2",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                // "required": true,
                "customPrivate": false
              },
              "disabled": true,
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "Suburb",
              "key": "prescribedAppointerSuburb",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              "disabled": true,
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "State",
              "key": "prescribedAppointerState",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false
              },
              "disabled": true,
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "PostCode",
              "key": "prescribedAppointerPostCode",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                "required": true,
                "customPrivate": false,
                "pattern": "^[0-9]+$"
              },
              "disabled": true,
            },
            {
              "label": "Telephone number",
              //"inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              "key": "prescribedAppointerTelephoneNumber",
              "type": "textfield",
              "input": true,
              "disabled": true,
            },
            {
              "label": "Fax number",
              //"inputMask": "(99) 9999-9999",
              "tableView": true,
              "persistent": true,
              "validate": {
                "required": false,
                "customPrivate": false
              },
              "key": "prescribedAppointerFaxNumber",
              "type": "textfield",
              "input": true,
              "disabled": true,
            },
            {
              "label": "Email",
              "tableView": true,
              "validate": {
                "required": true
              },
              "key": "prescribedAppointerEmail",
              "type": "email",
              "input": true,
              "disabled": true,
            },
          ]
        }, // prescribed appointer
        //{
        //  "type": "textfield",
        //  "input": true,
        //  "tableView": true,
        //  "inputType": "text",
        //  "inputMask": "",
        //  "label": "name",
        //  "key": "prescribedAppointerName",
        //  "placeholder": "",
        //  "prefix": "",
        //  "suffix": "",
        //  "multiple": false,
        //  "defaultValue": "",
        //  "protected": false,
        //  "unique": false,
        //  "persistent": true,
        //  "validate": {
        //    "required": true,
        //    "customPrivate": false
        //  }
        //},
        //// Add the abn check
        //{
        //  "type": "textfield",
        //  "input": true,
        //  "tableView": true,
        //  "inputType": "text",
        //  "inputMask": "",
        //  "label": "ABN/ACN",
        //  "key": "prescribedAppointerABN",
        //  "placeholder": "",
        //  "prefix": "",
        //  "suffix": "",
        //  "multiple": false,
        //  "defaultValue": "",
        //  "protected": false,
        //  "unique": false,
        //  "persistent": true,
        //  "validate": {
        //    "required": true,
        //    "customPrivate": false
        //  }
        //},
        //{
        //  "type": "button",
        //  "label": "Check",
        //  "key": "checkPrescribedAppointerABN",
        //  "disableOnInvalid": false,
        //  "input": true,
        //  "tableView": true,
        //  "action": "custom",
        //  "custom": "window.onCheck3(data.prescribedAppointerABN)"
        //},
        //{
        //  "type": "htmlelement",
        //  "input": false,
        //  "tableView": true,
        //  "content": "ABN is valid",
        //  "inputMask": "",
        //  "key": "abnValidTextPrescribedAppointer",
        //  "prefix": "",
        //  "suffix": "",
        //  "multiple": false,
        //  "protected": false,
        //  "unique": false,
        //  "persistent": true,
        //  "customClass": "abnSuccess",
        //  "conditional": {
        //    "json": {
        //      "==": [
        //        {
        //          "var": "data.displayabnValidationSuccessPrescribedAppointer"
        //        },
        //        true
        //      ]
        //    }
        //  }
        //},
        //{
        //  "type": "htmlelement",
        //  "input": false,
        //  "tableView": true,
        //  "content": "ABN is not valid",
        //  "inputMask": "",
        //  "key": "abnNotValidTextPrescribedAppointer",
        //  "prefix": "",
        //  "suffix": "",
        //  "multiple": false,
        //  "protected": false,
        //  "unique": false,
        //  "persistent": true,
        //  "customClass": "abnFailure",
        //  "conditional": {
        //    "json": {
        //      "==": [
        //        {
        //          "var": "data.displayabnValidationFailurePrescribedAppointer"
        //        },
        //        true
        //      ]
        //    }
        //  }
        //},

        //// Start - Address, tele and email
        //{
        //  "type": "textfield",
        //  "input": true,
        //  "tableView": true,
        //  "inputType": "text",
        //  "inputMask": "",
        //  "label": "Postal Address",
        //  "key": "prescribedAppointerPostalAddress",
        //  "placeholder": "",
        //  "prefix": "",
        //  "suffix": "",
        //  "multiple": false,
        //  "defaultValue": "",
        //  "protected": false,
        //  "unique": false,
        //  "persistent": true,
        //  "validate": {
        //    "required": true,
        //    "customPrivate": false
        //  }
        //},
        //{
        //  "type": "textfield",
        //  "input": true,
        //  "tableView": true,
        //  "inputType": "text",
        //  "inputMask": "",
        //  "label": "Suburb",
        //  "key": "prescribedAppointerSuburb",
        //  "placeholder": "",
        //  "prefix": "",
        //  "suffix": "",
        //  "multiple": false,
        //  "defaultValue": "",
        //  "protected": false,
        //  "unique": false,
        //  "persistent": true,
        //  "validate": {
        //    "required": true,
        //    "customPrivate": false
        //  }
        //},
        //{
        //  "type": "textfield",
        //  "input": true,
        //  "tableView": true,
        //  "inputType": "text",
        //  "inputMask": "",
        //  "label": "State",
        //  "key": "prescribedAppointerState",
        //  "placeholder": "",
        //  "prefix": "",
        //  "suffix": "",
        //  "multiple": false,
        //  "defaultValue": "",
        //  "protected": false,
        //  "unique": false,
        //  "persistent": true,
        //  "validate": {
        //    "required": true,
        //    "customPrivate": false
        //  }
        //},
        //{
        //  "type": "textfield",
        //  "input": true,
        //  "tableView": true,
        //  "inputType": "text",
        //  "inputMask": "",
        //  "label": "PostCode",
        //  "key": "prescribedAppointerPostCode",
        //  "placeholder": "",
        //  "prefix": "",
        //  "suffix": "",
        //  "multiple": false,
        //  "defaultValue": "",
        //  "protected": false,
        //  "unique": false,
        //  "persistent": true,
        //  "validate": {
        //    "required": true,
        //    "customPrivate": false,
        //    "pattern": "^[0-9]+$"
        //  }
        //},
        //{
        //  "label": "Telephone number",
        //  "inputMask": "(99) 9999-9999",
        //  "tableView": true,
        //  "persistent": true,
        //  "validate": {
        //    "required": false,
        //    "customPrivate": false
        //  },
        //  "key": "prescribedAppointerTelephoneNumber",
        //  "type": "textfield",
        //  "input": true
        //},
        //{
        //  "label": "Email",
        //  "tableView": true,
        //  "validate": {
        //    "required": true
        //  },
        //  "key": "prescribedAppointerEmail",
        //  "type": "email",
        //  "input": true
        //},
        {
          "title": "Extra Submissions",
          "collapsible": false,
          "key": "panel",
          "type": "panel",
          "label": "Panel",
          "input": false,
          "tableView": false,
          "components": [
            {
              "type": "fileupload",
              "label": "Submissions",
              "disabled": false,
              "placeholder": "Extra submissions",
              conditional: {
                "json": {
                  "===": [
                    {
                      "var": "data.formName"
                    },
                    "nt-application"
                  ]
                }
              }
            },
            {
              "type": "fileupload",
              "label": "Attachments",
              "disabled": false,
              "placeholder": "Attachments",
              conditional: {
                "json": {
                  "===": [
                    {
                      "var": "data.formName"
                    },
                    "nt-application"
                  ]
                }
              }
            },
          ]
        }, //extra submissions
        //{
        //  "type": "htmlelement",
        //  "input": false,
        //  "tableView": true,
        //  "content": "Submissions",
        //  "inputMask": "",
        //  "key": "submissionsText",
        //  "prefix": "",
        //  "suffix": "",
        //  "multiple": false,
        //  "protected": false,
        //  "unique": false,
        //  "persistent": true
        //},
        //{
        //  "type": "htmlelement",
        //  "input": false,
        //  "tableView": true,
        //  "content": "Please click <a target='_blank' href='http://www7.austlii.edu.au/cgi-bin/viewdoc/au/legis/nt/consol_act/ccopa2004520/s28.html'>here</a> to know more.",
        //  "inputMask": "",
        //  "key": "submissionsText",
        //  "prefix": "",
        //  "suffix": "",
        //  "multiple": false,
        //  "protected": false,
        //  "unique": false,
        //  "persistent": true
        //},
        // Add the file upload
        // supporting submissions
        // {
        //   "type": "MyNewComponent",
        //   "label": "customComp",
        //   "storage": "blob",
        //   // "file": {
        //   //     "url": "https://slack.com/api/files.upload",
        //   //     "options": {
        //   //         "base": "https://slack.com/api/files.upload"
        //   //     }
        //   // }
        //   "file": "https://slack.com/api/files.upload"
        // },
        //{
        //  "type": "fileupload",
        //  "label": "Supporting submissions",
        //  "disabled": false,
        //  "placeholder": "Supporting submissions",
        //  conditional: {
        //    "json": {
        //      "===": [
        //        {
        //          "var": "data.formName"
        //        },
        //        "nt-application"
        //      ]
        //    }
        //  }
        //},
        {
          "type": "button",
          "label": "Submit",
          "key": "submit",
          "disableOnInvalid": false,
          "input": true,
          "tableView": false
        }
      ];

        Formio.createForm(document.getElementById('formio'), {
          "components": formComponents
          }
        )
        .then(function(form){
          formData = form;
          if (jsonDataUrl != undefined) {
            httpClient.get<any>(that.baseUrl+ 'api/SampleData/GetJsonData?filepath=' + jsonDataUrl).subscribe(data1 => {
              form.submission = {
                data: data1
              }
            })
          } else {
            formData.submission ={data: {...formData.submission.data, ...{formId: formId}, ...{formName: 'nt-application'}, ...{prescribedAppointerName: 'Resolution Institute',
              ...{prescribedAppointerABN: '69008651232'}, ...{prescribedAppointerPostalAddress1: 'Suite 602, Level 6, Tower B, Zenith Centre'},
              ...{prescribedAppointerPostalAddress2: '821-843 Pacific Highway'}, ...{prescribedAppointerState: 'NSW'},
              ...{prescribedAppointerSuburb: 'Chatswood'}, ...{prescribedAppointerPostCode: '2067'},
            ...{prescribedAppointerTelephoneNumber: '(02) 9251 3366'}, ...{prescribedAppointerFaxNumber: '(02) 9251 3733'},
            ...{prescribedAppointerEmail: 'nominations@resolution.institute'}}}}
          }
          
          form.on('submit', function(form: any) {
            var serviceResponse = that.appService.getUrls();
            var pdfUrl = "/documents/" + formId +".pdf";
            var pdfData = {
              "key": AppService.generatedPdfKey,
              "url": []
            };
            pdfData.url.push(pdfUrl);
            serviceResponse.push(pdfData);
            form.data.files_submitted = that.appService.getUploadedFilesString();
            let today = new Date();
            form.data.submission_date = today.toString();
            var jsonToServer = {...form.data, ...{files: serviceResponse}};

            let jsonToServer_ = JSON.parse(JSON.stringify(jsonToServer))

           
            today.setHours(0, 0, 0, 0);
            let newComponent = {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "Date Submitted",
              "key": "submission_date",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "Test_Default",
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "===": [
                    {
                      "var": "data.submission_date"
                    },
                    "yes"
                  ]
                }
              }
            };
            
            let filesComponent = {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "Files Submitted",
              "key": "files_submitted",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "Test_Default",
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "===": [
                    {
                      "var": "data.files_submitted"
                    },
                    "yes"
                  ]
                }
              }
            };

            let panel = {
              "title": "Form details",
              "key": "panel",
              "type": "panel",
              "components": [newComponent, filesComponent]
            }

            formComponents.unshift(<any>panel);
            let component = {
              type: 'form',
              title: 'Resolution Institute Quickfiles application',
              display: 'form',
              components: formComponents
            };

            let submission = {
              //owner: jsonToServer_.formName,
              //_id: formId,
              //modified: today.toString(),
              data: jsonToServer
            };

            let options = {
              ignoreLayout: true
            };

            let exporter = new FormioExport(component, submission, options);

            let config = {
              download: false,
              filename: formId + '.pdf'
            };

            /*
            exporter.toPdf(config).then((pdf) => {
              // download the pdf file
              pdf.save(config.filename);
            });
            */

            exporter.toPdf(config).then((pdf) => {
              return pdf.output('datauristring');
            }).then((datauri_base64) => {
              if (datauri_base64) {
                // console.log(datauri_base64);

                var pdfObject = {};
                pdfObject["base64file"] = datauri_base64;
                pdfObject["filename"] = config.filename;

                that.httpClient.post<any>(that.baseUrl + 'api/SampleData/SaveToPdf', pdfObject).subscribe(result => {
                  if (result) {
                    console.log('PDF uploaded!!');

                    that.httpClient.post<any>(that.baseUrl + 'api/SampleData/PostFormData', jsonToServer).subscribe(result => {
                      if (result) {
                        console.log('Form data uploaded!!');

                        that.router.navigateByUrl('/thankyou');
                      }
                      else {
                        alert('There was an error with the submision, please try again. -1');

                        return false;
                      }
                    }, error => {
                      console.error(error);

                      return false;
                    });
                  }
                  else {
                    alert('There was an error with the submision, please try again. -2');

                    return false;
                  }
                }, error => {
                  console.error(error);

                  return false;
                });
              }
            }).catch(function (error) {
              alert('There was an error with the submision, please try again. -3');

              return false;
            });

          });
        });

        // this.formData = {
        //     data: {
        //       "firstName": "Laksh",
        //       "lastName": "Mikkili"
        //     }
        //   };
        (window as any).onCheck = function onCheck(abnVal: any){
          that.ngxLoader.start();
          formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccess: false}, ...{displayabnValidationFailure: false}}}
        // console.log("abnVal is" + abnVal);
        // console.log("form is", formData);
        httpClient.get<any>(baseUrl + 'api/SampleData/FindABN?searchText='+abnVal).subscribe((result: any) => {
          if(result.ABRPayloadSearchResults.response.businessEntity) {
              formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccess: true}, ...{displayabnValidationFailure: false}}}
          } else {
              formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccess: false}, ...{displayabnValidationFailure: true}}}
          }
          that.ngxLoader.stop();
      });
      };

        (window as any).onCheck1 = function onCheck1(abnVal: any){
          that.ngxLoader.start();
          formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessRespondent: false}, ...{displayabnValidationFailureRespondent: false}}}
        // console.log("abnVal is" + abnVal);
        // console.log("form is", formData);
        httpClient.get<any>(baseUrl + 'api/SampleData/FindABN?searchText='+abnVal).subscribe((result: any) => {
          if(result.ABRPayloadSearchResults.response.businessEntity) {
              formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessRespondent: true}, ...{displayabnValidationFailureRespondent: false}}}
          } else {
              formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessRespondent: false}, ...{displayabnValidationFailureRespondent: true}}}
          }
          that.ngxLoader.stop();
      });
      };
    
      (window as any).onCheck2 = function onCheck2(abnVal: any){
        that.ngxLoader.start();
        formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessAdjudicator: false}, ...{displayabnValidationFailureAdjudicator: false}}}
      // console.log("abnVal is" + abnVal);
      // console.log("form is", formData);
      httpClient.get<any>(baseUrl + 'api/SampleData/FindABN?searchText='+abnVal).subscribe((result: any) => {
        if(result.ABRPayloadSearchResults.response.businessEntity) {
            formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessAdjudicator: true}, ...{displayabnValidationFailureAdjudicator: false}}}
        } else {
            formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessAdjudicator: false}, ...{displayabnValidationFailureAdjudicator: true}}}
        }
        that.ngxLoader.stop();
      });
      };
      (window as any).onCheck3 = function onCheck3(abnVal: any){
        that.ngxLoader.start();
        formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessPrescribedAppointer: false}, ...{displayabnValidationFailurePrescribedAppointer: false}}}
      // console.log("abnVal is" + abnVal);
      // console.log("form is", formData);
      httpClient.get<any>(baseUrl + 'api/SampleData/FindABN?searchText='+abnVal).subscribe((result: any) => {
        if(result.ABRPayloadSearchResults.response.businessEntity) {
            formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessPrescribedAppointer: true}, ...{displayabnValidationFailurePrescribedAppointer: false}}}
        } else {
            formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessPrescribedAppointer: false}, ...{displayabnValidationFailurePrescribedAppointer: true}}}
        }
        that.ngxLoader.stop();
      });
      };
    }
    onSubmit(form: any) {
      var serviceResponse = this.appService.getUrls();
      var pdfUrl = "/documents/" + this.formId +".pdf";
            var pdfData = {
              "key": AppService.generatedPdfKey,
              "url": []
            };
            pdfData.url.push(pdfUrl);
            serviceResponse.push(pdfData);
      var jsonToServer = {...form.data, ...{files: serviceResponse}};
      console.log(jsonToServer);
      this.httpClient.post<any>(this.baseUrl + 'api/SampleData/PostFormData', jsonToServer).subscribe(result => {
        if (result) {
          console.log('the form data is submitted to queue')
        this.router.navigateByUrl('/thankyou');
        } else {
          console.log('form is not saved');
        }
      }, error => {
        console.error(error)
        // display a message that the form is not saved
      });
    }
}
